module.exports = __webpack_public_path__ + "static/media/shanghai.4ec142eb.jpg";